import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { toast } from 'react-toastify';

//redux
import { Provider } from "react-redux"; //Wrap this with your root component which is <app /> Gives access to central state
import { createStore } from "redux"; //creates the central store
import reducer from "./store/reducer"; //Where all your reducers are
import Cookies from 'js-cookie'

const store = createStore(reducer); //link the reducer to the central store so it can change it
export default store;

toast.configure({
    position: "bottom-center",
    autoClose: 5000,
    hideProgressBar: false,
    newestOnTop: false,
    closeOnClick: true,
    rtl: false,
    pauseOnVisibilityChange: true,
    draggable: true,
    pauseOnHover: true
});

// ====== HANDLE AUTO LOGOUT =====

// Count of open tabs
let dwemco_count = parseInt(localStorage.getItem("dwemco-count"));

if (!Cookies.get("dwemco-cookie")) {
    // New browser -> logout
    localStorage.clear();
    Cookies.set("dwemco-cookie", (new Date()).toTimeString());
    sessionStorage.setItem("dwemco-session", 1);
}
else if (!sessionStorage.getItem("dwemco-session")) {
    // New tab -> logout if no other tabs open
    if (!dwemco_count) localStorage.clear();
    sessionStorage.setItem("dwemco-session", 1);
}
else if (!dwemco_count) {
    // No other tabs -> if away for too long, logout
    const refresh_seconds = 100000 * 3;
    let current_time = (new Date()).getTime();
    let departed = parseInt(sessionStorage.getItem("dwemco-departed"));
    if (current_time - departed > refresh_seconds) {
        localStorage.clear();
    }
}
// SSO redirects/refreshes causes dwemco_count to fall below 0
// Which prevents automatic log out when the tab is closed and messes up having multiple tabs open of the app
// Check to make sure its not less than 0, and if so make it 0
if (dwemco_count < 0) {
    dwemco_count = 0;
}
// Increment tab count
localStorage.setItem("dwemco-count", (dwemco_count || 0) + 1);

window.addEventListener("beforeunload", () => {
    // Upon app instance closing, reduce tab count and set time of closing
    let dwemco_count = parseInt(localStorage.getItem("dwemco-count"));
    localStorage.setItem("dwemco-count", dwemco_count - 1);
    sessionStorage.setItem("dwemco-departed", (new Date()).getTime());
});

// ===============================

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>,

    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();